

import { useNavigate } from 'react-router-dom';
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import useAppState from '../../context/AppContext';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { APP_URLS } from '../../const/AppConst';
import MgpButton from '../../elements/MgpButton/MgpButton';
import { accessJsonAttr, isMobile } from '../../utils/utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { EffectCoverflow, Navigation, Pagination } from 'swiper/modules';
import MgpMessage from '../../elements/MgpMessage/MgpMessage';
import { formatFrAmount } from '../../utils/dataUtils';
import { IGarantie, IOffersDetails } from '../../context/model';


type GuarantyOfferFormComponentProps = {
    handleSwitchPage: () => void;
    garanties: IGarantie[]
    options: Record<string, IOffersDetails | null>
}

type  GuarantyOfferFormData = {
  offerCode: string;
}



export default function GuarantyOfferFormComponent({handleSwitchPage, garanties, options}: Readonly<GuarantyOfferFormComponentProps>) {

  const navigate = useNavigate();
  
  const {
    state: { proposition, updatedProposition, additionalData, jwtToken },
    dispatch,
  } = useAppState();

  const validationSchema = Yup.object().shape({
   
  });

  const {
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm<GuarantyOfferFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      offerCode : updatedProposition?.offerCode ? updatedProposition?.offerCode : "",
    },
    resolver: yupResolver(validationSchema),
  });

  const demande = getValues('offerCode');

  const onNextAction = (data: GuarantyOfferFormData) => {
    if (garanties.length > 0) {
      let tempUpdatedPropo = updatedProposition;
      if(tempUpdatedPropo) {
        tempUpdatedPropo.offerCode = data.offerCode;
      }
  
      dispatch({type: 'UPDATE_UPDATED_PROPOSITION', updatedProposition: tempUpdatedPropo});
      
      handleSwitchPage();
    } else {
      dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.recapPage});
      navigate({
        pathname: APP_URLS.recapPage,
        search: `?id=${proposition!.propositionId}`,
      });
    }
   
  
  };

  const onPreviousAction = () => {
    let url = APP_URLS.infoPersoRecapPage;
    if (proposition?.configuration.canBeAddedBeneficiaries) {
      if(additionalData?.hasPartner || additionalData?.hasChild) {
        url = APP_URLS.familyDocumentsPage;
      } else {
        url = APP_URLS.infoBeneficiaryStep0Page;
      } 
    }
    dispatch({type: 'BACK_INFO_STEP', path: url});
    navigate({
      pathname: url,
      search: `?id=${proposition!.propositionId}`,
    });
  };

  const handleChooseDemande = (e: any, option: string) => { 
    e.preventDefault();
    setValue('offerCode' , option, {shouldValidate : true, });
  };

  const style = {
    transform: 'scale(1.05)',
    gap: "30px",
    opacity: 1,
    border: "1px solid #DC0055",
  };

  const styleAutre = {
    opacity: 0.6,
  };

    return (            
      <form style={{width: '100%'}}>
        {
          garanties.length === 0 && <MgpMessage type="danger" message='Les garanties non trouvées' hasCloseBtn={true}/>
        }
        {!isMobile() && garanties.length > 0 &&
          <div className="grid-flex page-content">
              {garanties.map((card, i) =>
                <div className={`p-md card-selected box m-y-md card ${card.garantieBase && 'option-base'} ${card.garantieRecommandee && 'option-recommendee'}`} key={i+1} style={demande === card.code ? style : (demande !== "" && demande !== card.code) ? styleAutre : {}}>
                  {card.garantieRecommandee ? <p className='ta-center fz-sm fushia box-chapo mb-md'>La plus adaptée à votre situation</p> : ""}
                  
                  <p className="fw-medium fz-lg mt-md mb-xs ta-center box-title">{card.titre}</p>
                  <p className='fz-sm box-subTitle ta-center'>{card.subTitre}</p>
                  
                  <div className='box-content'>
                    {card.couvertures.map((el, i) => 
                      <p className='fz-sm' key={i+1}><i className='icon-coche fushia fz-xs pr-xs' /><span className='fz-sm' dangerouslySetInnerHTML={{ __html:  el.description }} /></p> 
                    )}
                    <p className='fz-sm m-y-sm' dangerouslySetInnerHTML={{ __html:  card.servicesInclusTexte }}></p>
                  </div> 

                  <div className='m-x-lg m-y-sm ta-center'>
                    <span className="border-bleu light full mt-md"></span>
                  </div>
                  
                  <p className='bleu fw-medium ta-center fz-md'>Votre cotisation*</p>
                  <p className='ta-center fz-sm'>(hors cotisation obligatoire)</p>

                  {(additionalData?.hasChild || additionalData?.hasPartner) ? 
                    <div>
                      <div className='ta-center'>
                        <p className='m-y-xs fz-lg fw-bold'>{formatFrAmount(options[card.code]?.debitedAmountFromBankAccount!) ?? ''} / <span className='fz-sm fw-medium'>mois</span></p>
                      </div>
                    </div>
                    :
                    <div className='ta-center m-y-md'>
                      <p className=''><span className='fz-xs pr-xs'>Pour vous</span><span className='fz-lg fw-bold'>{formatFrAmount(options[card.code]?.debitedAmountFromBankAccount!) ?? ''} /</span><span className='fz-sm fw-medium'>mois</span></p> 
                    </div>
                  }

                  <p className='fz-xs m-y-sm ta-center'>*Sur la base des informations déclarées</p>
                  
                  <div className='ta-center'>
                    {demande === card.code ?
                      <MgpButton  type="button" text="C'est mon choix" color='bleu' size="small" icon="coche"/> :
                      <MgpButton  type="button" text="Choisir cette formule" color='bleu' size="small"  onClick={(e) => handleChooseDemande(e, card.code)}/>
                    } 
                  </div>
                </div>
              )}
          </div>
        }

        {isMobile() && garanties.length > 0 &&
          <div className='grid-flex va-center jc-center'>        
          <Swiper
            effect={'coverflow'}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            initialSlide={updatedProposition?.offerCode ? garanties.findIndex(el => el.code === updatedProposition?.offerCode) : garanties.findIndex(el => el.garantieRecommandee)}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: false,
            }}
            pagination={true}
            modules={[EffectCoverflow, Pagination, Navigation]}
            className="mySwiper"
            
          >
           
            {garanties.map((card, i) =>
              <SwiperSlide key={i+1}>
                <div className={`shadow-noir card-mobile mb-lg p-xs bg-blanc ${card.garantieBase && 'option-base'} ${card.garantieRecommandee && 'option-recommendee'}`} key={i+1}>
                  {card.garantieRecommandee ? <p className='ta-center fz-sm fushia box-chapo-mobile box-chapo'>La plus adaptée à votre situation</p> : ""}
                      
                    <p className="fw-medium fz-md mt-sm mb-xs pt-xs ta-center">{card.titre}</p>
                    <p className='fz-sm box-subTitle ta-center'>{card.subTitre}</p>

                    {card.couvertures.map((el, i) => 
                      <p className='fz-sm' key={i+1}><i className='icon-coche fushia fz-xs' /><span className='fz-sm' dangerouslySetInnerHTML={{ __html:  el.description }} /></p> 
                    )}
                        
                    <p className='fz-sm m-y-sm' dangerouslySetInnerHTML={{ __html:  card.servicesInclusTexte }}></p> 
                    
                    <div className='m-x-sm ta-center'>
                      <span className="border-bleu light full m-y-xs"></span>
                    </div>

                    <p className='bleu fw-medium ta-center fz-md'>Votre cotisation*</p>
                    <p className='ta-center mb-xs fz-sm'>(hors cotisation obligatoire)</p>

                  {(additionalData?.hasChild || additionalData?.hasPartner) ? 
                    <div>
                      <div className='ta-center'>
                        <p className='m-y-xs fz-lg fw-bold'>{formatFrAmount(options[card.code]?.debitedAmountFromBankAccount!) ?? ''} / <span className='fz-sm fw-medium'>mois</span></p>
                      </div>
                    </div>
                    :
                    <div className='ta-center m-y-md'>
                      <p className=''><span className='fz-xs pr-xs'>Pour vous</span><span className='fz-lg fw-bold'>{formatFrAmount(options[card.code]?.debitedAmountFromBankAccount!) ?? ''} /</span><span className='fz-sm fw-medium'>mois</span></p> 
                    </div>
                  }

                    <p className='fz-xs m-y-sm ta-center'>*Sur la base des informations déclarées</p>

                    <div className='ta-center mb-sm'>
                      {demande === card.code ?
                        <MgpButton  type="button" text="C'est mon choix" color='bleu' size="small" icon="coche"/> :
                        <MgpButton  type="button" text="Choisir cette formule" color='bleu' size="small"  onClick={(e) => handleChooseDemande(e, card.code)}/>
                      } 
                    </div>       
                </div>
              </SwiperSlide>  
            )}
           
          </Swiper>
          </div>
        }
        
        {garanties.length > 1 &&
          <div className='m-y-sm pb-sm' style={garanties.length > 2 ? {textAlign:'center'} : {}}>
              {errors && accessJsonAttr(errors, 'offerCode') && <p className="fushia m-y-md fw-medium fz-md">(*) Veuillez choisir une offre ci-dessus.</p>}
              <button className='cta-blanc cta-small' onClick={() => handleSwitchPage()}>Comparer les garanties</button>
          </div>
        }
        
        <StickButtonsBloc disabledPreviousButton={false} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onNextAction)}/> 
      </form>
  )
}
